import * as React from 'react';
import { connect } from 'react-redux';
import { Card, IconButton, Notification, BookingItem, Pagination } from '../';
import PAGINATE from '../../data/paginate';
import Loader from '../Loader/Loader';

interface Props {
  bookings: any;
  vehicleTypes: Array<any>;
  loading: boolean;
  handleUpdate: Function;
  dispatch: Function;
}

interface State {
  page: number;
}

class BookingRelationList extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      page: 0,
    };
  }

  async componentDidMount() {
    await this.props.handleUpdate(this.state.page);
  }

  render() {
    if (this.props.loading) {
      return <Loader fullwidth />;
    }

    if (!this.props.bookings.length) {
      return <Notification type="default">No bookings found</Notification>;
    }

    return (
      <>
        {this.props.bookings
          .slice(0, PAGINATE.bookingRelations.MAX)
          .map((booking) => (
            <BookingItem
              hideControls
              key={booking.id}
              link={`/bookings/${booking.id}`}
              booking={booking}
              vehicleTypes={this.props.vehicleTypes}
            />
          ))}
        <br />
        <Pagination
          page={this.state.page}
          lastPage={this.props.bookings.length <= PAGINATE.payments.MAX}
          handleUpdate={(page) => {
            this.setState({ page });
            this.props.handleUpdate(page);
          }}
        />
      </>
    );
  }
}

export default connect()(BookingRelationList);
